import React from "react";
import { Link } from "react-router-dom";
import { Leaf, HeartHandshake, Recycle, ShieldCheck } from "lucide-react";
import { IMAGES } from "@/data/site";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";
import useReveal from "@/hooks/useReveal";

const PILLARS = [
  { icon: Leaf, title: "Pureté absolue", desc: "Des formules courtes, sans parabènes, silicones ni perturbateurs endocriniens. Uniquement l'essentiel, certifié bio." },
  { icon: HeartHandshake, title: "Commerce équitable", desc: "Nous rémunérons justement les coopératives de femmes et garantissons une traçabilité totale de chaque ingrédient." },
  { icon: Recycle, title: "Éco-responsabilité", desc: "Emballages 100% recyclables ou rechargeables, flacons en verre, encres végétales et logistique optimisée." },
  { icon: ShieldCheck, title: "Sans cruauté", desc: "Certifiée Cruelty-free et Vegan. Aucun de nos produits ni ingrédients n'est testé sur les animaux." },
];

export default function Ethique() {
  useReveal([]);
  return (
    <>
      <PageHero
        tag="Notre engagement"
        title="Notre <em>Éthique</em>"
        subtitle="Une beauté qui ne triche pas : transparente, équitable et respectueuse du vivant."
        image={IMAGES.ethiqueHero}
      />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "Notre éthique" }]} />

      <section className="products-section reveal">
        <div className="section-header">
          <p className="section-tag">Nos quatre piliers</p>
          <h2 className="section-title">Des valeurs <em>non négociables</em></h2>
        </div>
        <div className="feature-grid" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <div className="feature-card" key={p.title}>
                <Icon size={28} color="var(--gold)" strokeWidth={1.5} />
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            );
          })}
        </div>
      </section>

      <section className="nature-section reveal">
        <div className="nature-image"><img src={IMAGES.nature} alt="Vallée des Roses" /></div>
        <div className="nature-text">
          <p className="section-tag">Notre promesse</p>
          <h2 className="section-title">Le respect, <em>à chaque étape.</em></h2>
          <blockquote>« Embellir sans nuire — ni à votre peau, ni à la terre, ni à celles qui la cultivent. »</blockquote>
          <p className="section-body">
            De la graine au flacon, nous contrôlons chaque maillon de la chaîne. C'est notre définition
            du luxe : un luxe conscient, qui a du sens.
          </p>
          <Link to="/pages/nos-cooperatives" className="btn-primary" style={{ alignSelf: "flex-start" }}>Nos coopératives</Link>
        </div>
      </section>

      <NewsletterSection />
    </>
  );
}
